import React, { Component, cloneElement, useEffect, useState } from "react";
import { Scrollbars } from "react-custom-scrollbars";
import {
  List,
  Edit,
  Create,
  SimpleForm,
  Toolbar,
  SaveButton,
  TextInput,
  email,
  regex,
  choices,
  Button,
  required,
  minLength,
  maxLength,
  CreateButton,
  SelectInput,
  Datagrid,
  TextField,
  EditButton,
  DateField,
  Filter,
  RefreshButton,
  TopToolbar,
  ExportButton,
  Pagination,
  SelectArrayInput,
  FormDataConsumer,
  useRecordContext,
  useResourceContext,
  useRedirect,
} from "react-admin";
import { Link } from "react-router-dom";
import Select from "react-select";
import {
  getLocalStorageKey,
  RUN_TIME_API_ENDPOINT,
  CommonHeaderOption,
  GetCurrentUserRoles,
} from "../common/common";
import Modal from "react-responsive-modal";
import Swal from "sweetalert2";
import GetAppIcon from "@mui/icons-material/GetApp";
import { useLocation } from "react-router-dom";

const validateName = [
  required(),
  minLength(2),
  maxLength(50),
  regex(/^(?=.{1,50}$)[a-z]+(?:[a-z]+)*$/, "Must be a valid name"),
];
const validateEmail = [
  required(),
  email(),
  maxLength(50),
  regex(/([a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3})/, "Must be a valid email"),
];
const validateRole = [
  required(),
  choices(["2", "3", "4"], "Must be Customer Service or Country admin"),
];
const validateUAERole = [
  required(),
  choices(["2", "3", "6", "7"], "Please select a valid role"),
];

const StatusField = ({ source }) => {
  const record = useRecordContext();
  return <span>{record[source] ? "Active" : "Inactive"}</span>;
};

const aggSalesArea = getLocalStorageKey("agg_sales_area");
const aggSalesAreaArray =
  aggSalesArea && Object.keys(aggSalesArea).length > 0 ? aggSalesArea : [];

const cementSalesAreas = getLocalStorageKey("cement_sales_areas");
const cementSalesAreasArray =
  cementSalesAreas && Object.keys(cementSalesAreas).length > 0
    ? cementSalesAreas
    : [];

const aggCementSalesArray = [...aggSalesAreaArray, ...cementSalesAreasArray];

const mappingAggCement = aggCementSalesArray.map(
  ({ sales_org, dist_channel, division }) => ({
    id: `${sales_org + "-" + dist_channel + "-" + division}`,
    name: `${sales_org + "-" + dist_channel + "-" + division}`,
  })
);

console.log("mappingAggCement", mappingAggCement);

const CreateRelatedSdoButton = () => {
  const record = useRecordContext();

  return (
    <Button
      component={Link}
      to={{
        pathname: "/change_log",
        search: `?filter={"id": ${record?.id}}`,
      }}
    >
      <div>
        <p className="view-button">View</p>
      </div>
    </Button>
  );
};
const Sample = () => {
  return (
    <div>
      <TextInput
        className="create-user-large-textfield"
        source="email"
        label="Employee business email "
        validate={validateEmail}
      />
      <div className="valid-emailid">
        Enter email with Lafarge Holcim business suite.{" "}
      </div>
    </div>
  );
};

const selectInputStyle = {
  width: 200,
};

const PostFilter = (props) => (
  <Filter {...props}>
    <TextInput source="email" label="Search by email.." />
    <TextInput source="username" label="Search by name.." />
    <SelectInput
      style={selectInputStyle}
      source="status"
      label="Search by status.."
      choices={[
        { id: true, name: "Active" },
        { id: false, name: "Inactive" },
      ]}
      validate={required()}
    />
  </Filter>
);

const EditToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
);

const CreateToolbar = (props) => {
  return (
    <Toolbar {...props}>
      <SaveButton />
    </Toolbar>
  );
};
const UserName = ({ record }) => {
  console.log("reocord ====>", record);
  return <span>{record?.username ? `${record?.username}` : "-"}</span>;
};

const topToolbarStyle = {
  zIndex: 2,
  display: "inline-block",
  float: "right",
};

const ListActions = (props) => {
  const location = useLocation();
  const resource = useResourceContext();

  const [modalShow, setModalShow] = React.useState(false);
  const [modalMsg, setModalMsg] = React.useState("");
  const [customFilterUrl, setCustomFilterUrl] = React.useState(location.search);

  const callExport = (e) => {
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    e.preventDefault();
    console.log("...", location.pathname, `${apiUrl}/${resource}_csv`);
    options.method = "GET";
    let _url = location?.pathname?.split("?");
    if (_url.length > 1 && _url[1] !== "") {
      console.log("params found");
      setCustomFilterUrl(_url[1]);
      fetch(`${apiUrl}/${resource}_csv?${_url[1]}`, options)
        .then((res) => {
          return res.json();
        })
        .then((jsonD) => {
          console.log("json= inside callback", jsonD.data);
          const msg = jsonD.data ? jsonD.data[0].message : "";
          Swal.fire({
            html: msg,
            icon: "success",
          });
        });
    } else {
      setCustomFilterUrl(location.search);
      fetch(`${apiUrl}/${resource}_csv?${location.search}`, options)
        .then((res) => {
          return res.json();
        })
        .then((jsonD) => {
          console.log("json= inside callback", jsonD.data);
          const msg = jsonD.data ? jsonD.data[0].message : "";
          Swal.fire({
            html: msg,
            icon: "success",
          });
        });
    }
  };
  const exporterModal = () => {
    return "";
  };

  const onClose = () => {
    setModalShow(false);
  };
  const {
    filterValues,
    total,
    maxResults,
    currentSort,
    exporter,
    permanentFilter,
    showFilter,
    displayedFilters,
    filters,
    basePath,
  } = props;
  const csvResource = resource + "_csv";
  return (
    <>
      <TopToolbar>
        {filters &&
          cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: "button",
          })}
        <CreateButton basePath={basePath} />
        <RefreshButton />
        <div>
          <button
            className="export-button"
            onClick={(e) => callExport(e)}
            disabled={total === 0}
            sort={currentSort}
            filter={{ ...filterValues, ...permanentFilter }}
          >
            {<GetAppIcon />}
            <span>Export</span>
          </button>
        </div>
      </TopToolbar>
      {modalShow && (
        <Modal open={modalShow} onClose={onClose} center>
          <h3>{modalMsg}</h3>
        </Modal>
      )}
    </>
  );
};

const WhiteListUsersPagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 50, 100, 150, 200]} {...props} />
);

export const WhiteListUsersList = (props) => {
  return (
    <>
      <Scrollbars className="scroll-container">
        <List
          {...props}
          exporter={props.exporter}
          pagination={<WhiteListUsersPagination />}
          sort={{ field: "created_at", order: "DESC" }}
          actions={<ListActions permissions={props} />}
          filters={<PostFilter />}
        >
          <Datagrid bulkActionButtons={false}>
            <TextField source="username" />
            {/* <UserName source="username" label="Name" /> */}
            <TextField source="email" />
            <TextField source="role_description" label="Role" />
            <StatusField source="status" />
            <DateField label="Access Created At" source="created_at" showTime />
            <CreateRelatedSdoButton label="Update Logs" />
            <EditButton label="Edit" />
            {/* <DeleteButton  label="Delete" /> */}
          </Datagrid>
        </List>
      </Scrollbars>
      {/* {
                    state.moodalShow &&
                    <Modal open={state.moodalShow} onClose={this.onClose} center>
                        <h3>{state.modalMsg}</h3>
                    </Modal>
                } */}
    </>
  );
};

const opcoDetails = getLocalStorageKey("opco");
const opco_id = opcoDetails && opcoDetails.id;
const postDefaultValue = { opco_id: opco_id };
const EditRedirect = (_basePath, _id, data) => `/whitelist_users`;

export const WhiteListUsersCreate = (props) => {
  const roleData = GetCurrentUserRoles();
  let locale = getLocalStorageKey("locale");
  console.log("roleData", roleData);
  const is_uae_csa = roleData ? roleData.indexOf("$csa") > -1 : false;
  console.log("is_uae_csa", is_uae_csa);
  const redirect = useRedirect();

  const onSuccess = () => {
    redirect(`/whitelist_users`);
  };
  let roleChoices = [
    { id: "4", name: "Country Super Admin" },
    { id: "3", name: "Country Admin" },
    { id: "2", name: "Customer Service" },
  ];
  let uaeRoleChoices = [
    { id: "4", name: "Country Super Admin" },
    { id: "3", name: "Country Admin" },
    { id: "2", name: "Customer Service" },
    { id: "6", name: "Internal Control" },
    { id: "7", name: "Marketing" },
  ];
  if (roleData.indexOf("$ca") == 0) {
    roleChoices = roleChoices.filter((role) => role.id !== "4");
    uaeRoleChoices = uaeRoleChoices.filter((role) => role.id !== "4");
  }
  console.log("uaeRoleChoices", uaeRoleChoices);
  return (
    <Create mutationOptions={{ onSuccess }} {...props}>
      <SimpleForm defaultValue={postDefaultValue} toolbar={<CreateToolbar />}>
        <Sample />
        {opco_id !== 13 && (
          <SelectInput
            className="create-user-large-textfield"
            source="role_id"
            label="Role"
            choices={roleChoices}
            validate={validateRole}
          />
        )}
        {opco_id === 13 && (
          <SelectInput
            className="create-user-large-textfield"
            source="role_id"
            label="Role"
            choices={uaeRoleChoices}
            validate={validateUAERole}
          />
        )}
        {locale == "en-ZA" && (
          <SelectArrayInput
            className="create-user-large-textfield"
            source="sales_orgs_list"
            label="Sales Organizations List"
            choices={mappingAggCement}
          />
        )}
      </SimpleForm>
    </Create>
  );
};

export const WhiteListUsersEdit = (props) => {
  const roleData = GetCurrentUserRoles();
  let locale = getLocalStorageKey("locale");
  console.log("roleData", roleData);
  const is_uae_csa = roleData ? roleData.indexOf("$csa") > -1 : false;
  console.log("is_uae_csa", is_uae_csa);
  let roleChoices = [
    { id: "2", name: "Customer Service" },
    { id: "3", name: "Country Admin" },
    { id: "4", name: "Country Super Admin" },
  ];
  let uaeRoleChoices = [
    { id: "4", name: "Country Super Admin" },
    { id: "3", name: "Country Admin" },
    { id: "2", name: "Customer Service" },
    { id: "6", name: "Internal Control" },
    { id: "7", name: "Marketing" },
  ];
  if (roleData.indexOf("$ca") == 0) {
    roleChoices = roleChoices.filter((role) => role.id !== "4");
    uaeRoleChoices = uaeRoleChoices.filter((role) => role.id !== "4");
  }
  return (
    <Edit {...props}>
      <SimpleForm toolbar={<EditToolbar />}>
        <TextInput
          className="edit-user-large-textfield"
          source="email"
          label="Employee business email"
          validate={validateEmail}
        />
        {opco_id !== 13 && (
          <SelectInput
            className="edit-user-large-textfield"
            source="role_id"
            label="Role"
            choices={roleChoices}
            defaultValue="role_id"
            validate={required()}
          />
        )}
        {opco_id === 13 && (
          <SelectInput
            className="edit-user-large-textfield"
            source="role_id"
            label="Role"
            choices={uaeRoleChoices}
            defaultValue="role_id"
            validate={required()}
          />
        )}
        <SelectInput
          className="edit-user-large-textfield"
          source="status"
          choices={[
            { id: true, name: "Active" },
            { id: false, name: "Inactive" },
          ]}
          defaultValue="status"
          validate={required()}
        />
        {/* <FormDataConsumer>
          {({ formData, getSource, ...rest }) => {
            const useSalesOrgMapping = formData.admin_users_sales_org_mappings
              .length
              ? formData.admin_users_sales_org_mappings.map(
                  ({ sales_org, distribution_channel, division }) => ({
                    id: `${
                      sales_org + "-" + distribution_channel + "-" + division
                    }`,
                    name: `${
                      sales_org + "-" + distribution_channel + "-" + division
                    }`,
                  })
                )
              : [];

            console.log("form data", formData, useSalesOrgMapping);

            return (
              <SelectArrayInput
                className="create-user-large-textfield"
                source="admin_users_sales_org_mappings"
                label="Sales Organizations List"
                choices={mappingAggCement}
              />
            );
          }}
        </FormDataConsumer> */}
        {locale == "en-ZA" && (
          <SelectArrayInput
            className="create-user-large-textfield"
            source="sales_orgs_list"
            label="Sales Organizations List"
            choices={mappingAggCement}
          />
        )}
      </SimpleForm>
    </Edit>
  );
};
